<template>
	<div class="kbBox" v-loading.fullscreen.lock="fullscreenLoading">
		<dialogBox :dialogFlag="fxFlag" wid="750px" @callFn="fxFlag = false" :title="`图表统计`">
			<div class="tjBoxs">
				<div class="tjBoxItem">
					<div ref="myChart1" style="width: 350px; height: 300px"></div>
				</div>
				<div class="tjBoxItem">
					<div ref="myChart2" style="width: 350px; height: 300px"></div>
				</div>
			</div>
			<div slot="footer"></div>
		</dialogBox>
		<div class="kbTit">
			<div class="kbFanh" @click="fhKeben">
				<i class="el-icon-arrow-left"></i>
				返回课本
			</div>
			<div class="kbTj" @click="fxFn">
				<img src="@/assets/img/tji.svg" alt="" />
				图表统计
			</div>
		</div>
		<div class="kbCont">
			<el-table ref="multipleTable" :data="tableData" header-row-class-name="btClass" tooltip-effect="dark" style="width: 100%">
				<el-table-column align="center" prop="createNickName" label="姓名"></el-table-column>
				<el-table-column align="center" prop="wcNum" label="已完成">
					<template slot-scope="scope">
						<div>
							{{ scope.row.rightNum + scope.row.wrongNum }}
						</div>
					</template>
				</el-table-column>
				<el-table-column align="center" label="正确数">
					<template slot-scope="scope">
						<div class="dfIcon">
							<img src="@/assets/img/zq.svg" alt="" />
							{{ scope.row.rightNum }}
						</div>
					</template>
				</el-table-column>
				<el-table-column align="center" label="错误数">
					<template slot-scope="scope">
						<div class="dfIcon dfIcon1">
							<img src="@/assets/img/cwu.svg" alt="" />
							{{ scope.row.wrongNum }}
						</div>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="wwNum" label="未完成">
					<template slot-scope="scope">
						<div>
							{{ scope.row.totalNum - scope.row.wrongNum - scope.row.rightNum }}
						</div>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="wclNum" label="完成率">
					<template slot-scope="scope">
						<div>{{ (((scope.row.wrongNum + scope.row.rightNum) / scope.row.totalNum) * 100).toFixed(2) }}%</div>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="dflNum" label="得分率">
					<template slot-scope="scope">
						<div>{{ (scope.row.rightNum + scope.row.wrongNum ? ((scope.row.rightNum / (scope.row.rightNum + scope.row.wrongNum)) * 100).toFixed(2) : '0.00') }}%</div>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
import * as echarts from 'echarts';
import dialogBox from '@/components/pubComponents/dialogBox';
export default {
	name: 'kebenDec',
	data() {
		return {
			fxFlag: false,
			tableData: [],
			myChart1: '',
			myChart2: '',
			tjData: {},
			fullscreenLoading: false,

			option1: {
				title: {
					text: `完成率`,
					left: '48.5%',
					top: '46%',
					subtextStyle: {
						color: '#9B9C9E',
						fontSize: 12,
						fontWeight: 'bold'
					},
					textAlign: 'center'
				},
				tooltip: {
					trigger: 'item'
				},
				legend: {
					bottom: 'bottom'
					// formatter: function (params) {
					//   console.log(params,999)
					//     return `${params} ${_this.option1.series[0].data.filter(item => item.name == params)[0].value}`;
					// },
				},
				series: [
					{
						name: '完成率',
						type: 'pie',
						radius: ['30%', '50%'],
						avoidLabelOverlap: false,
						label: {
							formatter: '{c}人',
							fontSize: 14
						},
						data: []
					}
				]
			},
			option2: {
				title: {
					text: `得分率`,
					left: '48.5%',
					top: '46%',
					subtextStyle: {
						color: '#9B9C9E',
						fontSize: 12,
						fontWeight: 'bold'
					},
					textAlign: 'center'
				},
				tooltip: {
					trigger: 'item'
				},
				legend: {
					bottom: 'bottom'
					// formatter: function (params) {
					//   console.log(params,999)
					//     return `${params} ${_this.option1.series[0].data.filter(item => item.name == params)[0].value}`;
					// },
				},
				series: [
					{
						name: '得分率',
						type: 'pie',
						radius: ['30%', '50%'],
						avoidLabelOverlap: false,
						label: {
							formatter: '{c}人',
							fontSize: 14
						},
						data: []
					}
				]
			}
		};
	},
	components: {
		dialogBox
	},
	props: ['bjId', 'ztId', 'userTextbookId'],
	methods: {
		init() {
			this.fullscreenLoading = true;
			console.log(this.bjId, this.ztId, 7777);
			this.$http
				.get('api/app/yydAnswerExam/list', {
					params: {
						bjId: this.bjId,
						bjExamId: this.userTextbookId,
						type: 1
					}
				})
				.then((res) => {
					this.fullscreenLoading = false;
					console.log(res, 9999);
					if (res.code == 200) {
						this.tableData = res.rows || [];
					}
				});
			this.$http.get(`api/app/yydAnswerExam/listEcharts/1/${this.userTextbookId}`).then((res) => {
				console.log(res, 9999);
				if (res.code == 200) {
					this.option1.series[0].data = res.data.list;
					this.option2.series[0].data = res.data.listDf;
				}
			});
		},
		fhKeben() {
			console.log(222);
			this.$emit('fhBtn', 'keben');
		},
		fxFn() {
			this.fxFlag = true;
			this.$nextTick(() => {
				// 初始化ECharts实例
				this.myChart1 = echarts.init(this.$refs.myChart1);
				// 使用刚指定的配置项和数据显示图表。
				this.myChart1.setOption(this.option1);
				// 初始化ECharts实例
				this.myChart2 = echarts.init(this.$refs.myChart2);
				// 使用刚指定的配置项和数据显示图表。
				this.myChart2.setOption(this.option2);
			});
		}
	},
	mounted() {
		this.init();
	}
};
</script>
<style lang="scss" scoped>
::v-deep .btClass {
	.cell {
		font-size: 14px !important;
		color: #000000 !important;
		font-weight: bold !important;
	}
}
.kbBox {
	.kbTit {
		height: 80px;
		border-bottom: 1px solid #eeeff2;
		display: flex;
		align-items: center;
		padding: 0 26px 0 16px;
		justify-content: space-between;
		> div {
			display: flex;
			align-items: center;
			font-size: 14px;
			cursor: pointer;
			color: #000000;
			line-height: 1;
			img {
				width: 22px;
				height: 22px;
				margin-right: 4px;
			}
			i {
				margin-right: 4px;
				font-size: 16px;
			}
		}
	}
}
.dfIcon {
	display: flex;
	align-items: center;
	justify-content: center;
	color: #1d7b3a;
	font-size: 14px;
	img {
		margin-right: 4px;
		width: 14px;
		height: 14px;
	}
}
.dfIcon1 {
	color: #fa4a1b;
}
.tjBoxs {
	display: flex;
	.tjBoxItem {
		margin-bottom: 30px;
		margin-top: -50px;
	}
}
</style>
